import React, { useReducer, useState } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import '../style/Home.css';
import { Container } from 'react-bootstrap';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import PasswordChange from './PasswordChange';
import { Row, Col } from 'react-bootstrap';
// import { Modal } from 'react-bootstrap';

// TODO : Date of birth hidden as date picker not workjing
// TODO : Update profile not set up for submitting

const formReducer = (state, event) => {
    if (event.reset) {
        return {
            dateOfBirth: '',
            firstname: '',
            surname: '',
            email: '',
        }
    }
    return {
        ...state,
        [event.name]: event.value
    }
}




const SupervisorProfile = ({ user }) => {

    const [submitting, setSubmitting] = useState(false);
    const [changePassword, setChangePassword] = useState(user.passwordChange);
    // const [dobDate, setDOBDate] = useState(new Date());
    const [formData, setFormData] = useReducer(formReducer, {
        surname: user.surname,
        firstname: user.firstname,
        dateOfBirth: user.dateOfBirth,
        email: user.email,
    });


    const handleSubmit = event => {
        event.preventDefault();
        setSubmitting(true);

        console.log('updating data for ', user.name);
    }

    const handleChange = event => {
        setFormData({
            name: event.target.name,
            value: event.target.value,
        })
    }

    function clickChangePassword() {
        setChangePassword(true);
    };

    return (
        <Container>
            <Row>
                <h3>Profile page for {user.name} </h3>
            </Row>
            <PasswordChange force={user.passwordChange} dbName='supervisor' open={changePassword} onClose={() => setChangePassword(false)}></PasswordChange>

            <Row>
                <Form onSubmit={handleSubmit} disabled={submitting}>
                    <Form.Group >
                        <Form.Label>
                            Email
                            <Form.Control type="textarea" name="email" placeholder={formData.email || ''} readOnly />
                        </Form.Label>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>
                            FirstName
                            <Form.Control type="textarea" name="firstname" onChange={handleChange} value={formData.firstname || ''} />
                        </Form.Label>
                        <Form.Label >
                            Surname
                            <Form.Control type="textarea" name="surname" onChange={handleChange} value={formData.surname || ''} />
                        </Form.Label>
                    </Form.Group>
                    <Row>
                        <Col>
                            <Button type="submit" disabled={true}>
                                Submit
                            </Button>
                        </Col>
                        <Col>
                            <Button className='my-4' onClick={clickChangePassword}>
                                Change Password
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>

        </Container>
    )
}

export default SupervisorProfile;